/* eslint-disable no-use-before-define */
import { FC } from 'react';
import { NormalizedCollectionHit } from '../../../types';

type HitProps = {
  hit: NormalizedCollectionHit;
};

export const Hit: FC<HitProps> = ({ hit }) => {
  return (
    <div className="collection-card-wrapper">
      <a href={hit.url} className="full-unstyled-link">
        <div className="collection-card collection-card--product">
          <div className="collection-card__inner">
            <div className="collection-card__image">
              <figure
                className="img img--wrapper img--cover collection-card__image--primary img--adapt"
                style={{ paddingBottom: '100%' }}
              >
                <img src={hit.image} alt={hit.imageAltName} />
              </figure>
            </div>
          </div>
        </div>

        <div className="collection-card-information">
          <div className="collection-card-information__wrapper center sr-title-wrapper">
            <span className="collection-card-information__text text-highlighted sr-title">{hit.title}</span>
          </div>
        </div>
      </a>
    </div>
  );
};
